export * from './delete-vorlage.service';
export * from './delete-vorlage.service.module';